import React from 'react';

import { Firm } from '@/services/types/firms-types';

import { FirmEmptyState } from '../ui/FirmEmptyState';
import { columns } from './columns';
import { DataTable } from './data-table';

interface FirmsTableProps {
  firms: Firm[];
  isLoading: boolean;

  onFirmClick: (firmId: string) => void;
  onEditClick: (event: React.MouseEvent, firmId: string) => void;
  onCreateClick: () => void;
  // Additional props needed for DataTable
  searchValue?: string;
  statusFilter?: string;
  onSearchChange?: (value: string) => void;
  onStatusChange?: (value: string) => void;
  onClearFilters?: () => void;
}

export const FirmsTable: React.FC<FirmsTableProps> = ({
  firms,
  isLoading,

  onFirmClick,
  onEditClick,
  onCreateClick,
  searchValue = '',
  statusFilter = 'all',
  onSearchChange = () => {},
  onStatusChange = () => {},
  onClearFilters = () => {},
}) => {
  if (isLoading) {
    return (
      <div className="p-4">
        <div className="h-10 bg-gray-100 rounded-md mb-4 animate-pulse" />
        <div className="space-y-2">
          {[...Array(5)].map((_, index) => (
            <div
              key={index}
              className="h-16 bg-gray-50 rounded-md animate-pulse"
              style={{ animationDelay: `${index * 100}ms` }}
            />
          ))}
        </div>
      </div>
    );
  }

  if (firms.length === 0) {
    return <FirmEmptyState onCreateClick={onCreateClick} />;
  }

  // Return the new DataTable component
  return (
    <DataTable
      columns={columns}
      data={firms}
      isLoading={isLoading}
      searchValue={searchValue}
      statusFilter={statusFilter}
      onSearchChange={onSearchChange}
      onStatusChange={onStatusChange}
      onClearFilters={onClearFilters}
      onFirmClick={onFirmClick}
      onEditClick={onEditClick}
      onCreateClick={onCreateClick}
    />
  );
};
